export const inr = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n || 0);

export const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(d);
};

export const paymentLabel = (method) => {
  if (method === "razorpay") return "Online";
  if (method === "cod") return "Cash on delivery";
  return method || "—";
};

const ORDER_STATUS_LABELS = {
  confirmed: "Order confirmed",
  processing: "Processing",
  shipped: "Shipped",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

const ORDER_STATUS_DETAILS = {
  confirmed: "We’ve received your order and will begin preparing it shortly.",
  processing: "Your order is being prepared at our studio.",
  shipped: "Your order is on its way. Delivery typically takes 5–7 days.",
  delivered: "Your order has been delivered. We hope you love it.",
  cancelled: "This order was cancelled.",
};

export const orderStatusLabel = (status) =>
  ORDER_STATUS_LABELS[status] || (status ? String(status).replace(/_/g, " ") : "Order confirmed");

export const orderStatusDetail = (status) =>
  ORDER_STATUS_DETAILS[status] || "We’ll update you as your order progresses.";

export const orderStatusHistory = (order) => {
  if (!order) return [];
  if (Array.isArray(order.status_history) && order.status_history.length > 0) {
    return order.status_history
      .filter((entry) => entry && entry.status)
      .map((entry) => ({
        status: entry.status,
        at: entry.at || order.created_at || null,
      }));
  }
  return [
    {
      status: order.status || "confirmed",
      at: order.updated_at || order.created_at || null,
    },
  ];
};
